import styled, { keyframes, css } from "styled-components";

import { Flex } from "@similarweb/ui-components/foundations";

const fadeOut = keyframes`
    from {
        opacity: 1;
    }
    to {
        opacity: 0;
    }
`;

export const StyledAIAgentPageLogo = styled(Flex)<{ isLogoFading?: boolean }>`
    opacity: ${({ isLogoFading }) => (isLogoFading ? 0 : 1)};
    animation: ${({ isLogoFading }) =>
        isLogoFading
            ? css`
                  ${fadeOut} 500ms ease
              `
            : "none"};
`;
